import { Component, mixins } from 'types-vue'
import { MatchMedia } from 'vue-component-media-queries';
import ShowVersionMixin from '@/Core/mixins/ShowVersion'

@Component
export default class Header extends mixins(ShowVersionMixin) {
  protected onClickLogo() {
    this.$router.push('/')
  }


  protected onClickMenu() {
    this.$emit('clickMenu')
  }
}